module.exports = __webpack_public_path__ + "img/samsung-galaxy-a50.4aea8e43.jpg";